import React from "react";
import { Box } from "../../design-system";

interface ModalContentProps {
  children: React.ReactNode;
}

const ModalContent: React.FC<ModalContentProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "32px",
        width: "100%",
        maxWidth: "421px",
        margin: "0 auto",
      }}
    >
      {children}
    </Box>
  );
};

export default ModalContent;
